import { render, staticRenderFns } from "./MiniPopup.vue?vue&type=template&id=fa15f5fa&scoped=true&"
import script from "./MiniPopup.vue?vue&type=script&lang=js&"
export * from "./MiniPopup.vue?vue&type=script&lang=js&"
import style0 from "./MiniPopup.vue?vue&type=style&index=0&id=fa15f5fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa15f5fa",
  null
  
)

export default component.exports